<template>
  <!--Logo start-->
  <div class="logo-main">
    <img :src="logoSrc" alt="Logo" height="30" />
  </div>
  <!--Logo End-->
</template>

<script>
import { ref, onMounted } from 'vue'
import axios from 'axios'
import state from '@/store/auth/state'

const apiBaseUrl = process.env.VUE_APP_API_BASE_URL

export default {
  props: {
    color: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const logoSrc = ref(require('@/assets/images/logo/logo-d.png'))

    const fetchCompanyLogo = async () => {
      if (state.companyID == 0 || !state.companyID)
        return

      try {
        const resp = await axios.get(`${apiBaseUrl}/csms/company-data/logo`, {
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${state.token}`
          },
          params: {
            _: Date.now()
          }
        })
        if (resp.data.size > 0) {
          logoSrc.value = URL.createObjectURL(resp.data)
        }
      } catch (err) {
        console.error('Failed to load company logo:', err)
      }
    }

    onMounted(fetchCompanyLogo)

    return { logoSrc }
  }
}
</script>
